import { Login, getUserInfo, GetSelfInfo } from '@/api/login'
import { dynamicRoutes } from '@/router'
import router from '@/router'
import { getToken, setToken, removeToken, setToken2 } from '@/utils/auth'

const user = {
	state: {
		userno: '',
		status: '',
		code: '',
		token: getToken(),
		name: '',
		avatar: '',
		introduction: '',
		roles: [],
		nenus: [],
		funs: [],
		setting: {
			articlePlatform: []
		}
	},

	mutations: {
		SET_CODE: (state, code) => {
			state.code = code
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_INTRODUCTION: (state, introduction) => {
			state.introduction = introduction
		},
		SET_SETTING: (state, setting) => {
			state.setting = setting
		},
		SET_STATUS: (state, status) => {
			state.status = status
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_USERNO: (state, userno) => {
			state.userno = userno
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		},
		SET_NENUS: (state, nenus) => {
			state.nenus = nenus
		},
		SET_FUNS: (state, funs) => {
			state.funs = funs
		}		
		
	},

	actions: {
		// 用户名登录
		LoginByUserNo({
			commit
		}, userInfo) {

			return new Promise((resolve, reject) => {
				Login(userInfo).then(response => {

					commit('SET_TOKEN', response.data.access_token) //提交变更	
					setToken2(response.data.access_token, response.data.expires_in)

					resolve(response) //回调结果
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 获取用户信息
		GetUserInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				GetSelfInfo().then(response => {
					if(response.code != 0) { // 由于mockjs 不支持自定义状态码只能这样hack
						return reject('error')
					}
					const res = response.data

					//定义 权限代码数组，初始值为报表中心的仪表盘
					var powerCodeList = ["reportcenter","reportcenter.monitorcenter"];
					if(res.powerfunlist) {
						powerCodeList = res.powerfunlist.split(";");
						if(powerCodeList.indexOf("reportcenter") == -1) {
							powerCodeList.push("reportcenter")
						}

						if(powerCodeList.indexOf("reportcenter.monitorcenter") == -1) {
							powerCodeList.push("reportcenter.monitorcenter")
						}
					}
					


					//根据获取的权限生成新的路由表函数(递归)
					function generateRoutesTable(Routes) {
						let RoutesTable = [];
						for(let x of Routes) {
							//判断是否有权限
							if(powerCodeList.indexOf(x.roleid) > -1) {
								let item = {};
								for(let k in x) {
									if(k == 'children') {
										item[k] = generateRoutesTable(x[k])
									} else {
										item[k] = x[k]
									}
								}
								RoutesTable.push(item);
							}
						};
						return RoutesTable;

					}

					let permissionRoutes = dynamicRoutes;
					commit('SET_NAME', res.username);
					commit('SET_NENUS', permissionRoutes);
                    commit('SET_FUNS', powerCodeList);
					router.addRoutes(permissionRoutes);

					router.addRoutes([{
						path: '*',
						hidden: true,
						redirect: "/"
					}]);

					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 前端 登出
		FedLogOut({
			commit
		}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				commit('SET_NAME', '')
				commit('SET_ROLES', [])
				commit('SET_NENUS', [])
				removeToken()
				resolve()
			})
		},

		// 动态修改权限
		ChangeRoles({
			commit
		}, role) {
			return new Promise(resolve => {
				commit('SET_TOKEN', role)
				setToken(role)
				getUserInfo(role).then(response => {
					const data = response.data
					commit('SET_ROLES', data.user.roles)
					commit('SET_NAME', data.user.userName)
					commit('SET_AVATAR', data.user.avatar)
					commit('SET_INTRODUCTION', data.user.introduction)
					resolve()
				})
			})
		}
	}
}

export default user